import React from 'react'
import SubHeader from '../../components/subHeader'
import OSDownloadCard from './components/OSDownloadCard'
import DownloadCategories from './components/downloadCategories'
import DownloadTabView from './components/downloadCategoryTab'
import MobileDownload from './components/MobileDownload'
import { useLocation } from 'react-router-dom'

const DownloadApp: React.FC = () => {
      const location = useLocation()
    return (
        <>
            <div className="downloads">
                <div className="container" style={{ color: '#111A24' }}>
                    <div className="row align-items-center justify-content-center text-center pt-5">
                        <div className="col-md-10 ">
                            <h2 className="downloads--title">{location.pathname == '/download' ? 'Download Klakpad App' : 'THANK YOU for registering, and welcome to the KLAKPAD Community.'}</h2>
                            <p className="downloads--text">
                               {location.pathname == '/download' ?' Explore the possibilities of Klakpad app and download the application for your Windows, Linux and MacOs' : 'Please keep an eye on your inbox for our first email to help kick-start your Journey with us.'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
            <DownloadCategories />     
            <MobileDownload />
        </>
    )
}

export default DownloadApp
